<template>
    <div class="dev-list">
        <div class="dev-list-search">
            <div class="search-btn">
                <el-button size="small" type="primary" @click="saveDev">保存修改</el-button>
                <el-select v-model="searchInfo.engineType" size="small" placeholder="引擎版本" style="margin-left: 10px">
                    <el-option
                            v-for="item in searchOptions.version"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <!--<el-button type="text" size="small" @click="advancedShow = !advancedShow">高级筛选</el-button>-->
            </div>
        </div>
        <div class="device-case-dev border-all">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="未分配设备" name="first">
                    <el-table ref="multipleTableFirst" :data="infoFirst.list" :height="tableHeightFirst"
                              :header-cell-style="{backgroundColor: '#efefef'}" :row-class-name="tableRowClassName"
                              @row-click="checkRowFirst"
                              tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChangeFirst">
                        <el-table-column type="selection" align="center" header-align="center" :selectable="canSelect"></el-table-column>
                        <el-table-column prop="id" label="ID" min-width="50px">
                            <template slot-scope="scope">
                                {{scope.row.cardType === 1 ? scope.row.id : "分层"}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="slotNo" label="槽位号"></el-table-column>
                        <el-table-column prop="deviceIp" label="设备IP"></el-table-column>
                        <el-table-column prop="deviceNo" label="设备编号"></el-table-column>
                        <el-table-column prop="version" label="设备版本" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="softinstalled" label="应用安装数量"></el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" placement="top"  v-if="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1">
                                    <span slot="content">{{showDeviceToolTip(scope.row)}}</span>
                                    <span :style="scope.row | statusClassFilter">
            {{scope.row | statusStr}}
                                <span :style="scope.row | authStatusClassFilter">
            {{scope.row | authStatusStr}}
          </span>
          </span>

                                </el-tooltip>
                                <span :style="scope.row | statusClassFilter" v-else>
            {{scope.row | statusStr}}
          </span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="groupName" label="分组"></el-table-column>-->
                        <el-table-column prop="disk" label="剩余空间">
                            <template slot-scope="scope">
                                {{ scope.row.disk + '%' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="分组内设备" name="second">
                    <el-table ref="multipleTableSecond" :data="infoSecond.list" :height="tableHeightSecond"
                              :header-cell-style="{backgroundColor: '#efefef'}"
                              @row-click="checkRowSecond"
                              tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChangeSecond">
                        <el-table-column type="selection" align="center" header-align="center"></el-table-column>
                        <el-table-column prop="id" label="ID" min-width="50px">
                            <template slot-scope="scope">
                                {{scope.row.cardType === 1 ? scope.row.id : "分层"}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="slotNo" label="槽位号"></el-table-column>
                        <el-table-column prop="slotNo" label="终端标志"></el-table-column>
                        <el-table-column prop="deviceIp" label="设备IP"></el-table-column>
                        <el-table-column prop="deviceNo" label="设备编号"></el-table-column>
                        <el-table-column prop="version" label="设备版本" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="softinstalled" label="应用安装数量" min-width="100px"></el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                    <span :style="scope.row | statusClassFilterIn">
            {{scope.row | statusStrIn}}
          </span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="groupName" label="分组"></el-table-column>-->
                        <el-table-column prop="disk" label="剩余空间">
                            <template slot-scope="scope">
                                {{ scope.row.disk + '%' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GroupListDevManage",
        data() {
            return {
                tableHeightFirst: 0,
                tableHeightSecond: 0,
                activeName: "first",
                infoFirst: {
                    success: false,
                    list: [],
                    total: 0
                },
                infoSecond: {
                    success: false,
                    list: [],
                    total: 0
                },
                infoSecondAll: {
                    success: false,
                    list: [],
                    total: 0
                },
                multipleSelectionFirst: [], // 选中的对象列表
                multipleSelectionSecond: [], // 选中的对象列表
                searchInfo: {
                    engineType: ""
                },
                searchInfoAll: {
                    engineType: ""
                },
                searchOptions: {
                    version: []
                },
            }
        },
        computed: {
            addDevOptions() {
                return [
                    {
                        label: "分层处理器",
                        value: 0
                    }, ...this.options
                ]
            }
        },
        watch: {
            ['searchInfo.engineType']() {
                this.init()
            }
        },
        methods: {
            showDeviceToolTip(row) {
                // console.log("row is " + JSON.stringify(row))
                if (row.isAuth === 0) {
                    return "该设备未通过认证，请联系运维人员"
                } else if (row.isAuth === 2) {
                    return "该设备认证过期，请联系运维人员"
                } else {
                    return "该认证已认证"
                }
            },
            /* 未分配设备表单击行事件 */
            checkRowFirst(r, c, e) {
                // console.log("r is " + JSON.stringify(r))
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && r.deviceUuid.length > 0 && r.isAuth === 1) {
                    this.$refs.multipleTableFirst.toggleRowSelection(r)
                }
            },
            /* 组内设备表单击行事件 */
            checkRowSecond(r, c, e) {
                this.$refs.multipleTableSecond.toggleRowSelection(r)
            },
            /* 获取未分配设备列表 */
            async getDeviceListForFirst() {
                let that = this
                if (that.activeName == "first") {
                    return await that.$post(that.$uri.device.deviceList, {groupId: 0, ...that.searchInfo})
                } else {
                    return await that.$post(that.$uri.device.deviceList, {groupId: 0, ...that.searchInfoAll})
                }
            },
            /* 获取分组内设备列表 */
            async getDeviceListForSecond() {
                let that = this
                if (that.activeName == "second") {
                    that.infoSecond = await that.$post(that.$uri.device.deviceList, {groupId: that.$store.state.groupInfo.id, ...that.searchInfo})
                    that.infoSecondAll = await that.$post(that.$uri.device.deviceList, {groupId: that.$store.state.groupInfo.id, ...that.searchInfoAll})
                } else {
                    that.infoSecond = await that.$post(that.$uri.device.deviceList, {groupId: that.$store.state.groupInfo.id})
                    that.infoSecondAll = await that.$post(that.$uri.device.deviceList, {groupId: that.$store.state.groupInfo.id})
                }
                // console.log("infoSecondAll is " + JSON.stringify(that.infoSecondAll))
                this.$refs.multipleTableSecond.toggleAllSelection()
            },
            async init() {
                let res = await this.getDeviceListForFirst()
                await this.getDeviceListForSecond()
                let list = []
                res.list.forEach(v => {
                    if (v.cardType === 1) {
                        list.push(v)
                    }
                })
                this.infoFirst.list = list
            },
            /* 获取选中的数据 */
            handleSelectionChangeFirst(val) {
                this.multipleSelectionFirst = val
            },
            /* 获取选中的数据 */
            handleSelectionChangeSecond(val) {
                this.multipleSelectionSecond = val
            },
            canSelect(row, index) {
                return !this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || row.deviceUuid.length === 0 || row.isAuth === 1
            },
            tableRowClassName({row, index}) {
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return 'not-auth-color';
                }
                return 'auth-color'
            },
            /* 获取所有引擎版本信息 */
            getEngineVersion() {
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    let list = []
                    list.push({
                        label: "全部",
                        value: ""
                    })
                    console.log("res is " + JSON.stringify(res))
                    res.list.forEach(v => {
                        list.push({
                            label: v.content,
                            value: v.code
                        })
                    })
                    this.searchOptions.version = list
                })
            },

            /* 保存修改 */
            saveDev() {
                let ips = []
                let gtDevNum = 0
                let hasMirrorOps = false

                // console.log("this.multipleSelectionFirst " + JSON.stringify(this.multipleSelectionFirst))
                this.multipleSelectionFirst.forEach(v => {
                    if (v.deviceMirrorOperationStatus != null && v.deviceMirrorOperationStatus != 5 && v.deviceMirrorOperationStatus != 14) {
                        // console.log("dev is " + JSON.stringify(dev))
                        hasMirrorOps = true
                        return
                    }
                    ips.push(v.deviceIp)
                    if (v.engineType >= 14 && v.engineType <= 16) {
                        gtDevNum++
                    }
                })
                // console.log("ips is " + JSON.stringify(ips))
                // console.log("this.multipleSelectionSecond " + JSON.stringify(this.multipleSelectionSecond))
                // console.log("this.infoSecond.list " + JSON.stringify(this.infoSecond.list))
                this.infoSecond.list.forEach(dev => {
                    let hasSelect = false
                    this.multipleSelectionSecond.forEach(v => {
                        if (v.id == dev.id) {
                            hasSelect = true
                        }
                        if (ips.indexOf(v.deviceIp) == -1) {
                            ips.push(v.deviceIp)
                        }
                        if (ips.indexOf(v.deviceIp) == -1) {
                            ips.push(v.deviceIp)
                        }
                    })
                    if (hasSelect == false) {
                        if (dev.deviceMirrorOperationStatus != null && dev.deviceMirrorOperationStatus != 5 && dev.deviceMirrorOperationStatus != 14) {
                            // console.log("dev is " + JSON.stringify(dev))
                            hasMirrorOps = true
                            return
                        }
                    }
                })

                if (hasMirrorOps) {
                    this.$confirm("所选云机正在进行镜像操作，不能执行分组操作", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    if (gtDevNum > 0) {
                        let tipContent = "高通版云机(" + gtDevNum + "台)暂不支持虚拟化容器，进入分组后不会产生容器，是否继续?"
                        this.$confirm(tipContent, "高通版暂不支持容器", {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'confirm-btn-blue',
                            iconClass: 'el-icon-c-blue',
                            cancelButtonText: '取消'
                        }).then(() => {
                            let devOut = []
                            this.infoSecondAll.list.forEach(v => {
                                let out = true
                                this.multipleSelectionSecond.forEach(item => {
                                    if (item.id === v.id) {
                                        out = false
                                        return
                                    }
                                })
                                if (out) {
                                    devOut.push(v.deviceIp)
                                }
                            })
                            const newDatas = []
                            const h = this.$createElement
                            if (devOut.length > 0) {
                                newDatas.push(h('p', null, "确认要将以下云机移出分组？"))
                                newDatas.push(h('p', null, devOut.join("，")))
                            } else {
                                newDatas.push(h('p', null, "确认要将勾选云机加入分组吗？"))
                            }
                            this.$confirm("提示", {
                                title: '提示',
                                message: h('div', null, newDatas),
                                confirmButtonText: '确定',
                                confirmButtonClass: 'confirm-btn-blue',
                                iconClass: 'el-icon-c-blue',
                                cancelButtonText: '取消'
                            }).then(() => {
                                let params = {
                                    id: this.$store.state.groupInfo.id,
                                    deviceIps: ips
                                }

                                this.$post(this.$uri.group.deviceMerge, params).then(res => {
                                    // console.log("saveDev res is " + JSON.stringify(res))
                                    if (res.success) {
                                        this.$message.success("关联成功")
                                        this.$router.go(0)
                                    }
                                })
                            })
                        }).catch(() => {
                        })
                    } else {
                        let devOut = []
                        this.infoSecondAll.list.forEach(v => {
                            let out = true
                            this.multipleSelectionSecond.forEach(item => {
                                if (item.id === v.id) {
                                    out = false
                                    return
                                }
                            })
                            if (out) {
                                devOut.push(v.deviceIp)
                            }
                        })
                        const newDatas = []
                        const h = this.$createElement
                        if (devOut.length > 0) {
                            newDatas.push(h('p', null, "确认要将以下云机移出分组？"))
                            newDatas.push(h('p', null, devOut.join("，")))
                        } else {
                            newDatas.push(h('p', null, "确认要将勾选云机加入分组吗？"))
                        }
                        this.$confirm("提示", {
                            title: '提示',
                            message: h('div', null, newDatas),
                            confirmButtonText: '确定',
                            confirmButtonClass: 'confirm-btn-blue',
                            iconClass: 'el-icon-c-blue',
                            cancelButtonText: '取消'
                        }).then(() => {
                            let params = {
                                id: this.$store.state.groupInfo.id,
                                deviceIps: ips
                            }

                            this.$post(this.$uri.group.deviceMerge, params).then(res => {
                                // console.log("saveDev res is " + JSON.stringify(res))
                                if (res.success) {
                                    this.$message.success("设置成功")
                                    // this.init()
                                    this.$router.go(0)
                                }
                            })
                        })
                    }
                }
            }
        },
        filters: {
            statusStr(row) {
                let status = ""
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    status = "推流中";
                } else if (row.deviceMirrorOperationStatus != null && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    // console.log("row is " + JSON.stringify(row))
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            status = "镜像准备中";
                            break
                        case 1:
                            status = "镜像保存中";
                            break
                        case 2:
                            status = "镜像保存失败";
                            break
                        case 3:
                            status = "镜像上传中";
                            break
                        case 4:
                            status = "镜像上传失败";
                            break
                        case 10:
                            status = "镜像下载中";
                            break
                        case 11:
                            status = "镜像下载失败";
                            break
                        case 12:
                            status = "镜像切换中";
                            break
                        case 13:
                            status = "镜像切换失败";
                            break
                        case 20:
                            status = '命令发送失败';
                            break;
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            status = "正常";
                            break
                        case 1:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "未更新"
                            }
                            break
                        case 2:
                            status = "应用安装中";
                            break
                        case 3:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "故障";
                            }
                            break
                        case 4:
                            status = "预启动";
                            break
                        case 5:
                            status = "清理中";
                            break
                        case 6:
                            status = "升级中";
                            break
                        case 7:
                            status = "应用结束中";
                            break
                    }
                }

                return status;
            },
            authStatusStr(row) {
                let status = ""

                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    status = "<认证失败>"
                }
                return status;
            },
            statusStrIn(row) {
                let status = ""
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    status = "推流中";
                } else if (row.deviceMirrorOperationStatus != null && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    // console.log("row is " + JSON.stringify(row))
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            status = "镜像准备中";
                            break
                        case 1:
                            status = "镜像保存中";
                            break
                        case 2:
                            status = "镜像保存失败";
                            break
                        case 3:
                            status = "镜像上传中";
                            break
                        case 4:
                            status = "镜像上传失败";
                            break
                        case 10:
                            status = "镜像下载中";
                            break
                        case 11:
                            status = "镜像下载失败";
                            break
                        case 12:
                            status = "镜像切换中";
                            break
                        case 13:
                            status = "镜像切换失败";
                            break
                        case 20:
                            status = '命令发送失败';
                            break;
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            status = "正常";
                            break
                        case 1:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "未更新"
                            }
                            break
                        case 2:
                            status = "应用安装中";
                            break
                        case 3:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "故障";
                            }
                            break
                        case 4:
                            status = "预启动";
                            break
                        case 5:
                            status = "清理中";
                            break
                        case 6:
                            status = "升级中";
                            break
                        case 7:
                            status = "应用结束中";
                            break
                    }
                }
                return status;
            },
            statusClassFilter(row) {
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    return {color: "green"};
                } else if (row.deviceMirrorOperationStatus && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            return {color: "green"};
                        case 1:
                            return {color: "green"};
                        case 2:
                            return {color: "red"};
                        case 3:
                            return {color: "green"};
                        case 4:
                            return {color: "red"};
                        case 10:
                            return {color: "green"};
                        case 11:
                            return {color: "red"};
                        case 12:
                            return {color: "green"};
                        case 13:
                            return {color: "red"};
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            return {color: "green"};
                        case 3:
                            return {color: "red"};
                        default:
                            return {color: "#eab820"};
                    }
                }
            },
            statusClassFilterIn(row) {
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    return {color: "green"};
                } else if (row.deviceMirrorOperationStatus && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            return {color: "green"};
                        case 1:
                            return {color: "green"};
                        case 2:
                            return {color: "red"};
                        case 3:
                            return {color: "green"};
                        case 4:
                            return {color: "red"};
                        case 10:
                            return {color: "green"};
                        case 11:
                            return {color: "red"};
                        case 12:
                            return {color: "green"};
                        case 13:
                            return {color: "red"};
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            return {color: "green"};
                        case 3:
                            return {color: "red"};
                        default:
                            return {color: "#eab820"};
                    }
                }
            },
            authStatusClassFilter(row) {
                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return {
                        color: "#aaa",
                        maxWidth: "100px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    };
                }
            }
        },
        beforeMount() {

        },
        mounted() {
            this.init()
            this.getEngineVersion()
            this.$nextTick().then(() => {
                this.tableHeightFirst = window.innerHeight - this.$refs.multipleTableFirst.$el.offsetTop - 300;
                this.tableHeightSecond = window.innerHeight - this.$refs.multipleTableSecond.$el.offsetTop - 300;
            })
        }
    };
</script>

<style lang="less" scoped>
    .dev-list {
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
            }
            .search-advanced {
                display: flex;
                flex-direction: column;
                .search-main {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .search-main-item {
                        width: 24%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        /*flex-grow: 1;*/
                        padding: 5px 10px;
                        span {
                            font-size: 12px;
                        }
                        .item-input {
                            width: 180px;
                        }
                    }
                }
                .search-btn {
                    padding: 0 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;
                }
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }
</style>